<h2 class="mat-h2 mb-4">Site Meeting Details</h2>

<section id="MeetingStub" [formGroup]="meeting">
    <div class="row">
        <div class="col-12">
            <div class="row">
                <!-- <div class="row">
                    <div class="col-sm-4">
                        <span class="label">WorkSite: </span>
                    </div>
                    <div class="col-sm-8">
                        <input class="form-control" matInput type="text" formControlName="WorkSite" placeholder="WorkSite"
                            *ngIf="ShowWorkSiteLabel" />
                        <span class="label" *ngIf="!ShowWorkSiteLabel">{{meeting.get("WorkSite").value}}</span>
                    
                    </div>
                </div> -->
                <!-- <div class="row">
                    <div class="col-sm-12">&nbsp;</div>
                </div> -->
                <div class="col-12">
                    <div class="row">
                        <div class="col-sm-12 col-12">
                            <span class="label">Meeting Title:</span>
                        </div>
                        <div class="col-sm-12 col-12">
                            <mat-form-field>
                                <input matInput formControlName="MeetingTitle" placeholder="Title" (change)="UpdateTitle($event)"/>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-12">
                    <div class="row">
                        <div class="col-sm-12 col-12">
                            <span class="label">Meeting Date:</span>
                        </div>
                        <div class="col-sm-12 col-12">
                            <mat-form-field>
                                <input matInput #datepickerctrl [matDatepicker]="picker" formControlName="MeetingDate" disabled="true" (dateChange)="SelectMeetingDate(datepickerctrl.value)" />
                                <mat-datepicker-toggle matSuffix [for]="picker" id="clPicker"></mat-datepicker-toggle>
                                <mat-datepicker  #picker disabled="false"> </mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-12">
                    <div class="row">
                        <div class="col-sm-12 col-12">
                            <span class="label">Meeting Type:</span>
                        </div>
                        <div class="col-sm-12 col-12">
                            <mat-form-field>  
                                <mat-select matNativeControl class="form-control" placeholder="Type" formControlName="MeetingType" (selectionChange)="SelectMeetingType($event)">
                                    <mat-option *ngFor="let type of meetingTypes" [value]="type.Code">{{type.Description}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-sm-12 col-12">
                            <span class="label">Meeting Notes:</span>
                        </div>
                        <div class="col-sm-12 col-12">
                            <mat-form-field>
                                <textarea matInput formControlName="Note" placeholder="Notes" (change)="UpdateNote($event)">
                                </textarea>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>